module.exports = __webpack_public_path__ + "img/bf.3f544e00.svg";